import { PropsWithChildren, ReactNode } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Breakpoint, Title } from '@treams/treams-ui';

const Container = styled(Flex)<{ $modal?: boolean }>`
	${(props) =>
		props.$modal
			? `
        height: 100%;
        min-width: 60vw;
        `
			: `
        height: 100vh;
        width: 100vw;
    `}
	background: #f5f7f9;
	overflow-y: auto;
	flex-direction: column;
`;

const Jumbo = styled(Flex)`
	background: linear-gradient(159.02deg, #443fc0 0%, #8e0eb8 20.56%);
	flex-direction: column;
`;

const JumboBody = styled.div`
	padding: 50px 0px;
	padding-bottom: 100px;
`;

const JumboTitle = styled(Title)`
	color: white;
	font-size: 64px;
	line-height: 64px;
	width: calc(100% - 40px);
	max-width: 560px;
	margin: 0px auto;

	@media screen and (max-width: ${Breakpoint.Small}) {
		font-size: 48px;
		line-height: 48px;
	}
`;

const JumboHeader = styled(Box)`
	width: calc(100% - 40px);
	max-width: 560px;
	margin: 0px auto;
`;

const JumboFooter = styled.div`
	svg {
		display: block;

		path {
			fill: #f5f7f9;
		}
	}
`;

const Note = styled.div`
	background: linear-gradient(180deg, #fff 25px, #d6f3ff 0);
	background-size: 100% 26px;
	padding: 26px 52px;
	max-width: 560px;
	width: calc(100% - 40px);
	position: relative;
	margin: 0px auto;
	margin-top: -10%;
	transform: translateY(-50px);
	box-shadow: 0px 2px 20px rgba(108, 118, 128, 0.2);

	p {
		color: #5b5b5b;
		line-height: 26px;
		font-family: Poppins;
		font-weight: 600;
		margin-bottom: 26px;

		&:last-child {
			margin-bottom: 0px;
		}
	}
`;

const NoteRuler = styled.div`
	position: absolute;
	top: 0px;
	left: 40px;
	width: 1px;
	height: 100%;
	background: rgba(233, 46, 54, 0.2);
`;

const Next = styled.div`
	margin: 0px auto;
	width: 200px;
	margin-bottom: 50px;
`;

export default function ProductLayout(
	props: PropsWithChildren<{ title: string; header?: ReactNode; cta?: ReactNode; modal?: boolean }>,
) {
	return (
		<Container $modal={props.modal}>
			<Jumbo flexGrow={1}>
				{props.header && <JumboHeader>{props.header}</JumboHeader>}
				<Box flexGrow={1} />
				<JumboBody>
					<JumboTitle>{props.title}</JumboTitle>
				</JumboBody>
				<JumboFooter>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 140" preserveAspectRatio="none">
						<path d="M0 116.667L60 101.135C120 85.3125 240 54.6875 360 35C480 15.3125 600 8.02083 720 7.80208C840 8.02083 960 15.3125 1080 15.5313C1200 15.3125 1320 8.02084 1380 3.86459L1440 0V140H1380C1320 140 1200 140 1080 140C960 140 840 140 720 140C600 140 480 140 360 140C240 140 120 140 60 140H0V116.667Z" />
					</svg>
				</JumboFooter>
			</Jumbo>
			<Note>
				<NoteRuler />
				{props.children}
			</Note>
			{props.cta && <Next>{props.cta}</Next>}
			<Box flexGrow={1} />
		</Container>
	);
}
